<template>
  <v-layout class="nx-dashboard-card-footer pt-3 ma-0" justify-start>
    <router-link class="theme--light nx-heading--level-5 d-flex align-center" v-if="to" :to="to">
      <span>{{ title }}</span>
      <v-icon>arrow_forward</v-icon>
    </router-link>
    <a v-else class="theme--light nx-heading--level-5 d-flex align-center" v-on="$listeners">
      <span>{{ title }}</span>
      <v-icon>arrow_forward</v-icon>
    </a>
  </v-layout>
</template>

<script>
export default {
  name: 'nx-dashboard-card-footer',
  props: {
    title: {
      type: String,
      required: true,
    },
    to: {
      type: Object,
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-dashboard-card-footer {
  a {
    text-decoration: none;
  }
}
</style>
